import * as React from "react";
const SvgArrowLongRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1.75rem", height: "0.75rem", viewBox: "0 0 28 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 6H27M27 6L22.5 0.5M27 6L22.5 11.5", stroke: "white", strokeWidth: 1.5 }));
export default SvgArrowLongRight;
